import { CodeListItem } from '../models/code-list-item';

export function formatCodelist(value?: CodeListItem | null): string {
  if (value) {
    return `${value.name}`;
  }
  return '-';
}
